import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'

const ToolTip = ({ text, style }) => {
    const [isHover, setIsHover] = useState(false);
    const handleMouseEnter = () => setIsHover(true);
    const handleMouseLeave = () => setIsHover(false);

    const toolTipPopUpStyle = {
		position: 'absolute',
        top: '0px',
        right: '0px',
        marginTop: '28px',
		border: "solid 1px black",
    	color: "black",
    	padding: "0.5rem 1rem",
		background: "#fff",
		boxShadow: "0.5rem 0.5rem 1rem 0 rgba(0, 0, 0, 0.4)",
        width: 'auto',
        whiteSpace: 'nowrap',
        ...style
    }

    return (
        <div
            style={{ display: 'flex', cursor: 'pointer', position: 'relative' }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <FontAwesomeIcon icon={faInfoCircle} />
            
            {/* Popup Information  */}
            {isHover && <div style={toolTipPopUpStyle}>{text}</div>}
        </div>
    )
}

export default ToolTip